



// 



import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import 'rxjs/add/operator/switchMap';

import { fadeInOut } from '../../services/animations';
import { BootstrapTabDirective } from "../../directives/bootstrap-tab.directive";
import { AccountService } from "../../services/account.service";
import { Permission } from '../../models/permission.model';


@Component({
    selector: 'quote-settings',
    template: require('./quote-settings.component.html'),
    styles: [require('./quote-settings.component.css')],
    animations: [fadeInOut]
})
export class QuoteSettingsComponent implements OnInit, OnDestroy {

    isServiceActivated = true;
    isQuoteActivated = false;
    isContractActivated = false;
    isOrgActivated = false;
    isCustomerActivated = false;

    readonly serviceTab = "service";
    readonly quoteTab = "quote";
    readonly contractTab = "contract"; 
    readonly orgTab = "org"; 
    readonly customerTab = "customer"; 

    fragmentSubscription: any;
    
    @ViewChild("tab")
    tab: BootstrapTabDirective;


    constructor(private route: ActivatedRoute, private accountService: AccountService) {
    }


    ngOnInit() {
        this.fragmentSubscription = this.route.fragment.subscribe(anchor => this.showContent(anchor));
    
    }


    ngOnDestroy() {
        this.fragmentSubscription.unsubscribe();
    }

    showContent(anchor: string) {


        this.tab.show(`#${anchor || this.serviceTab}Tab`);
    }


    isFragmentEquals(fragment1: string, fragment2: string) {

        if (fragment1 == null)
            fragment1 = "";

        if (fragment2 == null)
            fragment2 = "";

        return fragment1.toLowerCase() == fragment2.toLowerCase();
    }


    onShowTab(event) {
        let activeTab = event.target.hash.split("#", 2).pop();
        console.log(activeTab)

        this.isServiceActivated = activeTab == this.serviceTab;
        this.isQuoteActivated = activeTab == this.quoteTab;
        this.isContractActivated = activeTab == this.contractTab;
        this.isOrgActivated = activeTab == this.orgTab;
        this.isCustomerActivated = activeTab == this.customerTab;
    }


    get canViewUsers() {
        return this.accountService.userHasPermission(Permission.viewUsersPermission);
    }

    get canViewRoles() {
        return this.accountService.userHasPermission(Permission.viewRolesPermission);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/quote-settings/quote-settings.component.ts